import React from 'react';

const ExpenseDetailModal = ({ isOpen, onClose, expense, loading, formatMoney }) => {
    if (!isOpen) return null;

    return (
        <>
            <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-danger text-white">
                            <h5 className="modal-title">
                                <i className="bi bi-receipt me-2"></i>รายละเอียดรายจ่าย
                            </h5>
                            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-danger" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <div className="mt-2 text-muted">กำลังโหลดข้อมูล...</div>
                                </div>
                            ) : expense ? (
                                <div className="d-flex flex-column gap-3">
                                    <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                                        <div>
                                            <div className="text-muted small">รหัสรายจ่าย</div>
                                            <div className="fw-bold fs-5 font-monospace">{expense.expense_code}</div>
                                        </div>
                                        <div className="text-end">
                                            <div className="text-muted small">วันที่บันทึก</div>
                                            <div className="fw-bold">
                                                {new Date(expense.created_at || expense.expense_date).toLocaleString('th-TH')}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-3">
                                        <div className="col-6">
                                            <div className="text-muted small">หมวดหมู่/รายการ</div>
                                            <div className="fw-semibold">{expense.category}</div>
                                        </div>
                                        <div className="col-6 text-end">
                                            <div className="text-muted small">จำนวนเงิน</div>
                                            <div className="fw-bold fs-4 text-danger">{formatMoney(expense.amount)} ฿</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-muted small">วิธีชำระ</div>
                                            <div>
                                                <span className={`badge ${expense.payment_method === 'transfer' ? 'bg-primary' : 'bg-success'}`}>
                                                    {expense.payment_method === 'transfer' ? 'โอนเงิน' : 'เงินสด'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-6 text-end">
                                            <div className="text-muted small">ผู้รับผิดชอบ</div>
                                            <div className="fw-semibold">{expense.responsible_name || '-'}</div>
                                        </div>
                                    </div>

                                    <div className="bg-light p-3 rounded border">
                                        <div className="text-muted small mb-1">หมายเหตุ</div>
                                        <div className="text-break">{expense.note || '-'}</div>
                                    </div>

                                    <div className="text-end text-muted small mt-2">
                                        บันทึกโดย: {expense.created_by_name || '-'}
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-4 text-muted">
                                    <i className="bi bi-exclamation-circle fs-1 d-block mb-2"></i>
                                    ไม่พบข้อมูลรายจ่าย
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>ปิด</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </>
    );
};

export default ExpenseDetailModal;
